import { EnumBase } from 'hay-core-react';
class VoucherTipoVoucherEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.voucher.tipovoucher.manual',
                'main.voucher.tipovoucher.pagamento',
            ],
            'main.voucher.tipovoucher.manual'
        );
    }
}

const instance = new VoucherTipoVoucherEnum();
export default instance;
